import ShareDialog from './ShareDialog';

export default ShareDialog;



// WEBPACK FOOTER //
// ./src/components/ShareDialog/index.js